
import React from 'react'
import Layout from "../components/utils/layout";
const EstersPlayground = () => {

    const screenId = "EstersPlayground"
    const charts = {
        deposits : {},
        western_union : {},
        accounts_by_postcode : {},
        active_children : {},
        new_and_additional_orders : {},
        order_types_examples : {},
        cards_without_order_id : {},
        braintree_partial_credits : {}
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default EstersPlayground
